jQuery(document).ready(function($) {

/** BEGIN Parallax Scroll */
$(window).scroll(function() {
  let scrollTop = $(window).scrollTop();
  let windowHeight = $(window).height();

  $('.parallax').each(function() {
      let sectionTop = $(this).offset().top;
      let sectionHeight = $(this).outerHeight();
      let sectionBottom = sectionTop + sectionHeight;

      if (scrollTop + windowHeight >= sectionTop && scrollTop <= sectionBottom) {
          let scrollPercent = (scrollTop - sectionTop + windowHeight) / (sectionHeight + windowHeight);
          let parallaxOffset = (scrollPercent * 100); // Calculate the parallax offset
          
          // Center the image and apply the vertical parallax effect
          $(this).find('.img-parallax').css('transform', 'translate(-50%, calc(' + (parallaxOffset - 100) + '%))');
      }
  });
});
/** END Parallax Scroll */

/** BEGIN Scroll to Section */
function scrollToSection(sectionName) {
  let targetSection = $(`[data-section="${sectionName}"]`);
  if (targetSection.length) {
      $('html, body').animate({
          scrollTop: targetSection.offset().top
      }, 1000);
  }
}

// Helper function to extract the section name from URL
function getSectionNameFromPath(path) {
  return path.split("/").filter(Boolean).pop();
}

// Function to update the active link based on the current section
function updateActiveLink(sectionName) {
  $('#navbarNavDropdown a.menu-link').removeClass('active'); // Remove active class from all links
  $(`#navbarNavDropdown a.menu-link[href$="${sectionName}"]`).addClass('active'); // Add active class to the correct link
}

// Function to handle AJAX content loading
function loadContent(href, sectionName) {
  $.ajax({
      url: href,
      type: 'GET',
      success: function(data) {
          // Assuming the content is wrapped in a specific element, e.g., #main
          let newContent = $(data).find('#main').html();
          $('#main').html(newContent);

          // Update the browser history
          history.pushState(null, null, href);

          // Scroll to the section after the content is loaded
          scrollToSection(sectionName);
          updateActiveLink(sectionName); // Update the active link
      },
      error: function() {
          console.log('An error occurred while loading the page.');
      }
  });
}

// Handle internal link clicks for AJAX navigation
$('#navbarNavDropdown a.menu-link').on('click', function(e) {
  let href = $(this).attr('href');
  let sectionName = getSectionNameFromPath(href);
  let currentPath = window.location.pathname.split("/").slice(0, -1).join("/");

  // Prevent the default link behavior
  e.preventDefault();

  // If navigating within the same base path or to a section
  if (href.startsWith(currentPath) || href === window.location.pathname) {
      if (window.location.pathname === href || href === `${currentPath}/${sectionName}`) {
          // If already on the correct page but a different section, just scroll to the section
          scrollToSection(sectionName);
          updateActiveLink(sectionName); // Update the active link
      } else {
          // Load new content via AJAX if navigating to a different section
          loadContent(href, sectionName);
      }
  } else {
      // Load new content via AJAX for different base path or section
      loadContent(href, sectionName);
  }
});

// Handle browser back/forward buttons
$(window).on('popstate', function() {
  let sectionName = getSectionNameFromPath(window.location.pathname);
  scrollToSection(sectionName);
  updateActiveLink(sectionName); // Update the active link
});

// Scroll to section on initial page load if there's a section in the URL
let initialSectionName = getSectionNameFromPath(window.location.pathname);
scrollToSection(initialSectionName);
updateActiveLink(initialSectionName); // Update the active link
/** END Scroll to Section */

/** BEGIN Enable Footer links to open in a new window */
$('.footer-navigation a[target="_blank"]').on('click', function(e) {
  e.preventDefault();
  var url = $(this).attr('href');
  window.open(url, '_blank');
});
/** END Enable Footer links to open in a new window */

// Initialise wow.js
new WOW().init();
});